import {Tooltip} from '@mui/material'
import React from 'react'

export default function NameText({text, fs, fw, num}: any) {
  let newNum = num || 8
  return (
    <Tooltip title={text}>
      <span style={{fontSize: fs || '14px', fontWeight: fw || '400'}}>
        {' '}
        {text && text.slice(0, newNum)}
        {text && text.length > newNum && '...'} {!text && '-'}
      </span>
    </Tooltip>
  )
}
